export default "__VITE_ASSET__BSyvCx0P__"